module.exports = __webpack_public_path__ + "static/media/ashiYokoage.b50dd8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/ashiYokoage.png
// module id = 1702
// module chunks = 1